// MEDIA PLAN
export const MEDIA_PLAN_REZERVISI = `Dugme "Rezerviši" služi za kreiranje rezervacija.`;
export const MEDIA_PLAN_UGOVOR = `Polje "Ugovor" služi za odabir postojećeg ugovora.`;
export const MEDIA_PLAN_PODUGOVOR = `Polje "Podugovor/Klijent" služi za odabir podugovora koji se nalazi na prethodno izabranom ugovoru. `;
export const MEDIA_PLAN_PROGRAM = `Program je deo filtera koji služi za generisanje Emisija i Rasporeda.`;
export const MEDIA_PLAN_PERIOD = `Period ne može biti u prošlosti.`;
export const MEDIA_PLAN_PREGLED = `Dugme "Pregled" služi za primenu filtera.`;
export const MEDIA_OZNACI_SVE = `Dugme "Dodaj sve" služi za dodavanje svih rasporeda istovremeno.`;
export const MEDIA_PLAN_REZ_DATUM_FILTER = `Primeni datumski filter na rezervacijama.`;
export const MEDIA_PLAN_OBRISI_IZABRANE = `Obriši izabrane rezervacije.`;
export const MEDIA_PLAN_SPOTOVI = `Prikaži sve spotove.`;
export const MEDIA_PLAN_EMISIJE_PRE_18 = `Prikaži samo emisije pre 18h.`;
export const MEDIA_PLAN_EMISIJE_POSLE_18 = `Prikaži samo emisije posle 18h.`;

// MONTAZA
export const MONTAZA_PROGRAM_DATUM =
  'Jedna montaža je jedinstveno određena sa Programom i Datumom.';
export const MONTAZA_DATUM = 'Datum ne može biti u prošlosti.';
export const MONTAZA_ZAPOCNI =
  'Dugme "Započni" služi za primenu filtera, odnosno za započinjanje montaže za odabrani Program i Datum.';
export const MONTAZA_SACUVAJ =
  'Dugme "Sačuvaj za posle" služi za oslobađanje započete montaže za odabranu kombinaciju filtera, tako da drugi ili isti korisnik kasnije može da pristupi toj montaži.';
export const MONTAZA_OBRISI = 'Dugme "Obriši" služi za brisanje montaže.';
export const MONTAZA_OPIS = 'Kratak opis montaže.';
export const MONTAZA_PREGLED_DANA =
  'Kartica "Pregled dana" služi za pregled spotova za koje su izvršene rezervacije za izabrani Program i Datum.';
export const MONTAZA_UREDJIVANJE =
  'Kartica "Uređivanje" služi za prikaz/izmenu podataka o odabranoj emisiji, prikaz svih rezervacija koje su vezane za odabranu emisiju, kao i za kopiranje/premeštanje rezervacija ili cele emisije.';
export const MONTAZA_MONTAZA =
  'Kartica "Montaža" služi za rad sa blokovima, rezervacijama i špicama.';
export const MONTAZA_PROVERI =
  'Dugme "Proveri server" služi za proveru stanja na serveru.';
export const MONTAZA_IZBOR_EMISIJE =
  'Polje "Emisija" služi za odabir postojeće Emisije za koju postoje rezervacije za odabrani Program i Datum.';
export const MONTAZA_SACUVAJ_EMISIJU =
  'Dugme "Sačuvaj" služi za čuvanje izmene podataka o odabranoj emisiji.';
export const MONTAZA_DESTINACIJA =
  'Filteri "Program" i "Datum" služe za prikaz emisija na koje želite da izvršite kopiranje/premeštanje.';
export const MONTAZA_KOPIRAJ_EMISIJU =
  'Dugme "Kopiraj" služi za kopiranje emisije.';
export const MONTAZA_PREMESTI_EMISIJU =
  'Dugme "Premesti" služi za premeštanje emisije.';
export const MONTAZA_KOPIRAJ_REZERVACIJU =
  'Dugme "Kopiraj" služi za kopiranje izabranih rezervacija na emisiju odabranu u destinaciji.';
export const MONTAZA_PREMESTI_REZERVACIJU =
  'Dugme "Premesti" služi za premeštanje izabranih rezervacija na emisiju odabranu u destinaciji.';
export const MONTAZA_KOPIRAJ_SVE =
  'Dugme "Kopiraj sve" služi za kopiranje svih rezervacija na emisiju odabranu u destinaciji.';
export const MONTAZA_PREMESTI_SVE =
  'Dugme "Premesti sve" služi za premeštanje svih rezervacija na emisiju odabranu u destinaciji.';
export const MONTAZA_RESETUJ_BLOKOVE =
  'Dugme "Resetuj blokove" služi za vraćanje svih blokova/rezervacija u nulti blok i brisanje svih špica koje su dodate.';
export const MONTAZA_DODAJ_U_NOVI_BLOK =
  'Dugme "Dodaj u novi blok" služi za dodavanje rezervacija u novi blok.';
export const MONTAZA_ULAZNA_SPICA =
  'Polje "Ulazna špica" služi za odabir ulazne špice. U ovom polju prikazuju se samo spotovi vrste "Špica".';
export const MONTAZA_IZLAZNA_SPICA =
  'Polje "Izlazna špica" služi za odabir izlazne špice. U ovom polju prikazuju se samo spotovi vrste "Špica".';
export const MONTAZA_UBACI_SPICE =
  'Dugme "Ubaci špice" služi za dodavanje odabranih špica u selektovani blok.';
export const MONTAZA_UBACI_U_SVE =
  'Dugme "Ubaci u sve blokove" služi za dodavanje odabranih špica u sve blokove odabrane emisije.';
export const MONTAZA_PROFILE =
  'Dugme "Profile" služi za kreiranje plejliste za odabranu emisiju i blokove.';
export const MONTAZA_VRATI_U_NULTI =
  'Dugme "Vrati u nulti blok" služi za vraćanje selektovane rezervacije u nulti blok.';
export const MONTAZA_OBRISI_BRENDIRANE_SPICE =
  'Dugme "Obriši brendirane špice" služi za brisanje brendiranih na osnovu nivoa odabranog u padajućem meniju "Nivo akcije".';
export const MONTAZA_OBRISI_BRENDIRANE_SPICE_U_BLOKU =
  'Dugme "Obriši brendirane špice iz bloka" služi za brisanje brendiranih špica u trenutno izabranom bloku.';
export const MONTAZA_UBACI_BRENDIRANE_SPICE =
  'Dugme "Ubaci brendirane špice na ceo dan" služi za dodavanje odabranih brendiranih špica na ceo dan.';
export const MONTAZA_UBACI_BRENDIRANE_SPICE_U_BLOK =
  'Dugme "Ubaci brendirane špice u blok" služi za dodavanje odabranih brendiranih špica u izabrani blok.';
export const MONTAZA_BRENDIRANE_SPICE =
  '"Nivo akcije" predstavlja odabir nivoa nad kojim se dodaju ili brišu brendirane špice.';
export const MONTAZA_UBACI_BSPICE_PO_AKCIJI =
  '"Ubaci brendirane špice" služi za dodavanje brendiranih špica na osnovu nivoa odabranog u padajućem meniju "Nivo akcije".';

// UGOVOR
export const UGOVOR_CILJNE_GRUPE =
  'Kartica "Ciljne grupe" sadrži ciljne grupe koje su ugovorene datim ugovorom, što se kasnije koristi za obračune i fakturisanje.';
export const UGOVOR_OTKAZI =
  'Dugme "Otkaži" služi za poništavanje unosa - poništava se i unos podugovora.';

export const PODUGOVOR_SACUVAJ =
  'Dugme "Sačuvaj" služi za čuvanje podataka o podugovoru. Podaci o podugovoru neće zapravo biti sačuvani dok se ne sačuva ugovor. Ovo uključuje i spotove podugovora.';
export const PODUGOVOR_CILJNE_GRUPE =
  'Kartica "Ciljne grupe podugovora" sadrži ciljne grupe koje su ugovorene datim podugovorom, što se kasnije koristi za obračune i fakturisanje.';
export const PODUGOVOR_SPOTOVI =
  'Svi podaci iz kartice "Spotovi podugovora" se koriste u Media planu.';

// EMISIJA
export const EMISIJA_GENERISI_RASPOREDE =
  'Generiši rasporede - služi za automatsko generisanje rasporeda na osnovu zadate cene po sekundi, osnovne cene po CPP, programa, vremena emitovanja, trajanja, datuma početka emitovanja, datuma završetka emitovanja i učestalosti emitovanja.';
export const EMISIJA_AZURIRAJ_RASPOREDE_CENAMA =
  'Klikom na dugme se vrši ažuriranje cena svih rasporeda na osnovu zadatog intervala ažuriranja';



// WEBPACK FOOTER //
// ./src/app/constants/tooltip-messages.ts